module.exports = ".link-to-admin-meshutaf-users-button {\n  line-height: 95%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin/admin.component.scss
// module id = ./src/app/admin/admin/admin.component.scss
// module chunks = main